import { render, staticRenderFns } from "./ComplainceRisk.vue?vue&type=template&id=67f4cc3b&scoped=true"
import script from "./ComplainceRisk.vue?vue&type=script&lang=js"
export * from "./ComplainceRisk.vue?vue&type=script&lang=js"
import style0 from "./ComplainceRisk.vue?vue&type=style&index=0&id=67f4cc3b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f4cc3b",
  null
  
)

export default component.exports